import React from "react";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { useLanguage } from "../../../../context/LanguageContext";
import "./StatusGuide.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(
      `Status guide field "${key}" is missing from the API response.`
    );
  }
  return value;
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    badge: requireField(f, "badge"),
    title: requireField(f, "title"),
    statuses: [1, 2, 3, 4].map((n) => ({
      key: requireField(f, `status${n}Key`),
      tone: requireField(f, `status${n}Tone`),
      label: requireField(f, `status${n}Label`),
      text: requireField(f, `status${n}Text`),
    })),
  };
};

const StatusGuide = () => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection(
    "track",
    "status-guide",
    buildModel
  );

  if (isLoading) {
    return (
      <section className="status-guide" dir={meta.dir}>
        <div className="status-guide__container">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="status-guide" dir={meta.dir}>
        <div className="status-guide__container">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "Status guide unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="status-guide" dir={meta.dir}>
      <div className="status-guide__container">
        <span className="status-guide__badge">{model.badge}</span>
        <h2 className="status-guide__title">{model.title}</h2>

        <div className="status-guide__grid">
          {model.statuses.map((status) => (
            <article key={status.key} className="status-guide__card">
              <span
                className={`status-guide__tag status-guide__tag--${status.tone}`}
              >
                <span className="status-guide__dot" aria-hidden="true" />
                {status.label}
              </span>
              <p className="status-guide__text">{status.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatusGuide;
